import {Component, OnInit} from '@angular/core';
import {NzIconService} from "ng-zorro-antd/icon";
import {PIDB_ICONS} from "../../shared/icons";
import {NzModalService} from "ng-zorro-antd/modal";
import {Router} from "@angular/router";
import {MsalService} from "@azure/msal-angular";
import {environment} from "../../../environments/environment";
import {StatisticsService} from "../../pages/file-analysis/services/statistics.service";
import {UserService} from "../../pages/file-analysis/services/user.service";
import {UserRoles} from "../../shared/utils/user-roles.utils";

/**
 * Parent component for 2 children, includes their header, footer.
 * The header contains the title of the project which will navigate to the landing page when clicked and the profile as a dropdown menu with an ability to sign out.
 * The footer includes inmind.ai logo.
 */
@Component({
    selector: 'PIDB-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {

    username: string = "";
    email: string = "";
    protected readonly userRole = UserRoles;

    constructor(private iconService: NzIconService, private modal: NzModalService, private router: Router, private user: UserService,
                private msalService: MsalService, private statistics: StatisticsService) {
        PIDB_ICONS.forEach((icon) => this.iconService.addIconLiteral(icon.name, icon.svgData));
    }

    /**
     * Navigate to sign out whenever sign out clicked from the profile dropdown.
     */
    signOut() {
        this.modal.confirm({
            nzTitle: `<div>Do you want to sign out ?</div>`,
            nzOkText: "Sign out",
            nzOnOk: () => {
                this.msalService.logoutPopup({
                    mainWindowRedirectUri: environment.authentication.logoutRedirectUrl
                });
            }
        });
    }

    /**
     * Get the first user account from the MSAL service instance and set the username and email properties of the component based on the properties of the retrieved user object.
     */
    ngOnInit(): void {
        let user = this.msalService.instance.getAllAccounts()[0];
        this.username = user.name ?? "Unknown";
        this.email = user.username ?? "Unknown";
        this.statistics.setUserId(String(user.idTokenClaims?.oid));
    }

    navigateToUpload() {
        if (this.router.url == "/home/file-upload") {
            this.router.navigateByUrl("");
        } else {
            this.router.navigateByUrl("/home/file-upload");
        }
    }

    goToPage(str: string){
        this.router.navigateByUrl(str);
    }

    getStringUpToLastSpace(input: string): string {
        const lastSpaceIndex = input.lastIndexOf(' ');

        // If there's no space, return the original string
        if (lastSpaceIndex === -1) {
            return input;
        }

        // Return the string up to the last space
        return input.substring(0, lastSpaceIndex);
    }
}
